import { termsMeta, termsSections } from '../content/termsOfService'

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-neutral-50 py-10 print:bg-white">
      <div className="mx-auto max-w-5xl px-4">
        <div className="rounded-lg border border-neutral-200 bg-white p-6 shadow-sm print:border-0 print:shadow-none sm:p-10">
          <h1 className="text-center font-serif text-2xl font-bold tracking-wide text-neutral-900">
            eKubur.my
            <br />
            Terms of Service
          </h1>
          <p className="mt-2 text-center text-xs uppercase tracking-widest text-neutral-500">
            Sections 1–30 · Consolidated
          </p>

          <table className="mx-auto mt-6 mb-8 text-sm">
            <tbody>
              <tr>
                <td className="pr-6 py-1 font-medium text-neutral-600">Owner</td>
                <td className="py-1 text-neutral-900">{termsMeta.owner}</td>
              </tr>
              <tr>
                <td className="pr-6 py-1 font-medium text-neutral-600">Operator</td>
                <td className="py-1 text-neutral-900">{termsMeta.operator}</td>
              </tr>
              <tr>
                <td className="pr-6 py-1 font-medium text-neutral-600">Version</td>
                <td className="py-1 text-neutral-900">{termsMeta.version}</td>
              </tr>
              <tr>
                <td className="pr-6 py-1 font-medium text-neutral-600">Effective Date</td>
                <td className="py-1 text-neutral-900">{termsMeta.effectiveDate}</td>
              </tr>
              <tr>
                <td className="pr-6 py-1 font-medium text-neutral-600">Last Updated</td>
                <td className="py-1 text-neutral-900">{termsMeta.lastUpdated}</td>
              </tr>
            </tbody>
          </table>

          <nav className="mb-10 rounded-lg bg-neutral-50 p-4 print:hidden" aria-label="Contents">
            <h2 className="mb-2 text-sm font-semibold text-neutral-900">Contents</h2>
            <ol className="list-decimal space-y-1 pl-5 text-sm text-primary-700">
              {termsSections.map((s) => (
                <li key={s.number}>
                  <a href={`#section-${s.number}`} className="hover:underline">
                    {s.title}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          {termsSections.map((s) => (
            <section key={s.number} id={`section-${s.number}`} className="mb-8 scroll-mt-6">
              <h2 className="mb-3 font-serif text-lg font-semibold text-neutral-900">
                {s.number}. {s.title}
              </h2>
              {s.paragraphs.map((p, i) => (
                <p key={i} className="mb-3 text-justify leading-relaxed text-neutral-800">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  )
}
